import { PLATFORM_VALUE, PLATFORM_CONFIG_ENUM } from '../component/platformConfig'

export default function toSourceName(platformId, currentDto) {
  if (platformId === PLATFORM_VALUE.CROSSBORDER) {
    return currentDto?.siteName || null
  }
  return PLATFORM_CONFIG_ENUM.has(platformId) ? PLATFORM_CONFIG_ENUM.get(platformId).label : null
}
